import {MessageBase} from './message-base';
import {SeriesSelectorType} from '../DoraWidget/dora-series-selector/data/series-selector-type';

export class MessageSeriesTypeSelected  extends MessageBase<MessageSeriesTypeSelected> {
  // tslint:disable-next-line:variable-name
  private _seriesSelectorType: SeriesSelectorType;

  constructor(seriesSelectorType: SeriesSelectorType) {
    super(MessageSeriesTypeSelected);
    this._seriesSelectorType = seriesSelectorType;
  }

 get seriesSelectorType(): SeriesSelectorType {
    return this._seriesSelectorType;
  }
}
